import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

export const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  const previousPathname = useRef(pathname);

  useEffect(() => {
    const pageChanged = previousPathname.current !== pathname;
    previousPathname.current = pathname;

    if (!hash) {
      window.scrollTo(0, 0);
      return undefined;
    }

    // Links like "/#subscription-demand" target sections that may render after data loads
    const id = decodeURIComponent(hash.slice(1));
    let attempts = 0;
    const timer = setInterval(() => {
      const target = document.getElementById(id);
      attempts += 1;
      if (target || attempts > 20) {
        clearInterval(timer);
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else if (pageChanged) {
          // Unknown section on a new page: start at the top. On the same page, stay put.
          window.scrollTo(0, 0);
        }
      }
    }, 100);
    return () => clearInterval(timer);
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
